const theme = {
  colors: {
    primary: '#0070f3',
  },
}

export default theme
